class AipetProductManager {
  constructor() {
    // 写死的基础数据
    this.state = {
      inputMax: 12,
      // 当前步骤
      currentStep: 1,
      // 是否是预售
      isPresale: false,
      // 预售的时间
      presaleDate: '2026/02/16',

      // Step 1: 模型选择
      step1: {
        selectedIndex: null,
        models: [
          {
            index: 0,
            variantId: window.aipetKumamonModel?.variantId || '47514198278319',
            title: window.aipetKumamonModel?.title || 'くまモン',
            price: Number(window.aipetKumamonModel?.price || 0),
            image: window.aipetKumamonModel?.image || '',
            isSelected: false
          },
          {
            index: 1,
            variantId: '46499343761583',
            title: 'ノア',
            price: 129800,
            image: 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/1.5x_a3ecef4f-f7b8-4717-976e-ab2fed4b2b7a.webp?v=1769138363',
            isSelected: false
          },
          {
            index: 2,
            variantId: '46499343794351',
            title: 'ニコ',
            price: 129800,
            image: 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/1.5x_1_6b653338-cea9-4ddf-9051-e40e4ee4b7c9.webp?v=1769138362',
            isSelected: false
          },
          {
            index: 3,
            variantId: '',
            title: '未選択',
            price: 0,
            image: 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/153_4x_2f0a837d-b566-406a-9655-07dea5a5b6c6.webp?v=1769418296',
            isSelected: false
          }
        ]
      },

      // Step 2: 套餐选择（数据由 template-product-aipet.liquid 的 aipet_show_free_plan 控制）
      step2: {
        plans: window.aipetStep2Plans || []
      },

      // Step 3: 配件选择
      step3: {
        accessories: [
          {
            index: 0,
            variantId: '46951962345647',
            title: 'バースデーセット（イエロー）',
            price: 2980,
            quantity: 1,
            isSelected: false,
            locked: false
          },
          {
            index: 1,
            variantId: '46951910768815',
            title: 'スタイ（ベージュ）',
            price: 2980,
            quantity: 1,
            isSelected: false
          },
          {
            index: 2,
            variantId: '46951916372143',
            title: 'スカーフ（オレンジ）',
            price: 2980,
            quantity: 1,
            isSelected: false
          },
          {
            index: 3,
            variantId: '46951957495983',
            title: 'おでかけセット（イエローバケットハット＋リュック）',
            price: 2980,
            quantity: 1,
            isSelected: false,
            locked: false
          }
        ]
      },

      // Step 4: 总价
      step4: {
        totalPrice: 0,
        shippingDate: '30営業日以内出荷'
      },

      step1Items: [],
      step2Items: [],
      // step3Items: [],  // 已注释 - Step 3 配件选择

      stepSelectEl: null
    };

    this.freeAccessoryPromotionContext = null;

    this.init();
  }

  init() {
    console.log('✅ AipetProductManager 初始化完成');
    console.log('📊 初始状态:', this.state);
    
    // 延迟绑定事件,确保 DOM 已加载
    setTimeout(() => {
      this.bindEvents();
      this.unlockStep();
    }, 100);
  }

  // ========== 事件绑定 ==========

  bindEvents() {
    console.log('🔗 开始绑定事件...');

    // Step 1: 模型选择
    const modelItems = document.querySelectorAll('#aipetProductStep1_Main .aipet-product-step1-item');
    console.log(`📦 找到 ${modelItems.length} 个模型元素`);
    this.state.step1Items = modelItems || [];
    
    modelItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        // 排除卡片图片与支援说明图标
        if (e.target.closest('.aipet-product-step1-item-img-searchicon') ||
            e.target.closest('.aipet-product-step1-kumamon-support-icon')) {
          console.log('⏭️ 忽略子元素点击');
          return;
        }
        console.log(`🖱️ 点击了模型 ${index}`);
        this.handleModelSelect(index);
      });
    });
    // Step 1: 监听第一步的下一步按钮
    const step1NextBtn = document.querySelector('#aipetProductStep1_Main .aipet-product-step1-next');
    step1NextBtn&&step1NextBtn.addEventListener('click', () => {
      console.log(`🖱️ 点击模型的下一步`);
      let step1Selected = this.state.step1.models.some(model => model.isSelected);
      if (!step1Selected) {return;}
      this.state.currentStep = 2;
      this.unlockStep();

      const firstAvailablePlanIndex = this.state.step2.plans.findIndex(plan => this.isPlanAvailable(plan));
      if (firstAvailablePlanIndex !== -1) {
        this.handlePlanSelect(firstAvailablePlanIndex);
      }
    });

    // Step 1 查看卡片
    const step1ViewCards = document.querySelectorAll('#aipetProductStep1_Main .aipet-product-step1-item-img-searchicon');
    step1ViewCards.forEach((imgEl, index) => {
      imgEl.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        myAipetDialogImgClick(imgEl.dataset.type);
      });
    });

    // Step 1: 熊本県復旧・復興支援说明弹窗
    const kumamonSupportIcon = document.querySelector('.aipet-product-step1-kumamon-support-icon');
    const kumamonSupportDialog = document.querySelector('.aipet-product-kumamon-support-dialog');
    const kumamonSupportMask = kumamonSupportDialog?.querySelector('.aipet-product-kumamon-support-dialog-mask');
    const kumamonSupportClose = kumamonSupportDialog?.querySelector('.aipet-product-kumamon-support-dialog-close');
    const setKumamonSupportDialogOpen = (show) => {
      if (!kumamonSupportDialog) return;
      kumamonSupportDialog.classList.toggle('active', show);
      kumamonSupportDialog.setAttribute('aria-hidden', String(!show));
      if (show) {
        kumamonSupportClose?.focus();
      } else {
        kumamonSupportIcon?.focus();
      }
    };

    kumamonSupportIcon?.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      setKumamonSupportDialogOpen(true);
    });
    kumamonSupportClose?.addEventListener('click', () => setKumamonSupportDialogOpen(false));
    kumamonSupportMask?.addEventListener('click', () => setKumamonSupportDialogOpen(false));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && kumamonSupportDialog?.classList.contains('active')) {
        setKumamonSupportDialogOpen(false);
      }
    });

    // Step 3 查看卡片
    const step3ViewCards = document.querySelectorAll('#aipetProductStep3_Cloth .aipet-product-step3-item-img-searchicon');
    step3ViewCards.forEach((imgEl, index) => {
      imgEl.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        openClothDialog(imgEl.dataset.type);
      });
    });

    // Step 2: 套餐卡片点击
    const planItems = document.querySelectorAll('#aipetProductStep2_Plan .aipet-product-step2-item');
    console.log(`📦 找到 ${planItems.length} 个套餐元素`);
    this.state.step2Items = planItems || [];
    this.syncFreePlanAvailability();
    planItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        console.log(`🖱️ 点击了套餐 ${index}`);
        
        // 排除点击数量按钮和月付/年付按钮
        if (e.target.closest('.aipet-product-step2-item-middle-num') || 
            e.target.closest('.aipet-product-step2-item-middle-top-right')) {
          console.log('⏭️ 忽略子元素点击');
          return;
        }
        this.handlePlanSelect(index);
      });
    });

    // Step 2: 月付/年付切换
    const typeButtons = document.querySelectorAll('.aipet-product-step2-item-middle-top-right > div');
    console.log(`📦 找到 ${typeButtons.length} 个月付/年付按钮`);
    
    typeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        console.log('🖱️ 切换月付/年付');
        this.handlePlanTypeChange(btn);
      });
    });

    // Step 2: 数量调整
    const quantityButtons = document.querySelectorAll('.aipet-product-step2-item-middle-num-plus, .aipet-product-step2-item-middle-num-minus');
    console.log(`📦 找到 ${quantityButtons.length} 个数量按钮`);
    
    quantityButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const action = btn.classList.contains('aipet-product-step2-item-middle-num-plus') ? 'plus' : 'minus';
        const inputId = btn.parentElement.querySelector('input')?.id;
        console.log(btn.parentElement.querySelector('input'))
        console.log('🖱️ 点击数量按钮:', inputId, inputId.match(/\d+/)?.[0]);
        if (inputId) {
          const planIndex = parseInt(inputId.charAt(inputId.length - 1));
          if (!isNaN(planIndex)) {
            console.log(`🖱️ 调整数量 ${action}`);
            this.handleQuantityChange(planIndex, action);
          }
        }
      });
    });

    // Step 2: 监听数量输入框变化
    const step2Inputs = document.querySelectorAll('.aipet-product-step2-item-middle-num-input');
    step2Inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const inputId = e.target.id;
        const planIndex = parseInt(inputId.match(/\d+/)?.[0]);
        if (!isNaN(planIndex)) {
          let value = parseInt(e.target.value) || 1;
          if (value < 1) value = 1;
          if (value > this.state.inputMax) value = this.state.inputMax;
          e.target.value = value;
          console.log(`🔢 直接输入数量: ${value}`)
          this.state.step2.plans[planIndex].quantity = value
          this.updatePlanTotal(planIndex)
          this.calculateTotal()
          this.updateCheckoutContent();
          this.updateStepSummary();
        }
      });
    });

    // Step 2: 监听第二步的下一步按钮
    const step2NextBtn = document.querySelector('#aipetProductStep2_Plan .aipet-product-step2-next');
    console.log('📦 找到第二步的下一步按钮:', step2NextBtn);
    if (step2NextBtn) {
      step2NextBtn.addEventListener('click', () => {
        console.log('🖱️ 点击第二步的下一步按钮');
        let step2Selected = this.state.step2.plans.some(plan => plan.isSelected);
        if (!step2Selected){
          return;
        }
        this.state.currentStep = 3;
        this.unlockStep();
      });
    }
    
    // ========== Step 3: 配件选择 ==========
    const accessoryItems = document.querySelectorAll('#aipetProductStep3_Cloth .aipet-product-step3-item');
    console.log(`📦 找到 ${accessoryItems.length} 个配件元素`);

    accessoryItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.aipet-product-step3-item-img-searchicon')) {
          console.log('⏭️ 忽略子元素点击');
          return;
        }
        console.log(`🖱️ 点击了配件 ${index}`);
        const accessory = this.state.step3.accessories[index];
        if (!accessory) return;
        // 锁定的配件（赠品）默认选中且不可取消
        if (accessory.locked) {
          console.log('🔒 该配件为赠品，强制选中，无法取消');
          accessory.isSelected = true;
          item.classList.add('selected');
          return;
        }
        accessory.isSelected = !accessory.isSelected;
        item.classList.toggle('selected', accessory.isSelected);
        this.calculateTotal();
        this.updateCheckoutContent();
        this.updateStepSummary();
        const step3Btn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-btn');
        if (step3Btn) {
          const anySelected = this.state.step3.accessories.some(acc => acc.isSelected);
          step3Btn.textContent = anySelected ? '次へ進む' : '選択せずに次へ';
        }
      });
    });

    this.initFreeAccessoryPromotion(accessoryItems);
    this.syncFreeAccessoryPromotion();

    // Step 3: 初始化默认选中状态（赠品默认选中）
    accessoryItems.forEach((item, index) => {
      const accessory = this.state.step3.accessories[index];
      if (accessory && accessory.isSelected) {
        item.classList.add('selected');
      }
    });
    {
      const step3Btn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-btn');
      if (step3Btn) {
        const anySelected = this.state.step3.accessories.some(acc => acc.isSelected);
        step3Btn.textContent = anySelected ? '次へ進む' : '選択せずに次へ';
      }
    }

    // Step 3: 监听第三步的下一步按钮
    const step3NextBtn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-btn');
    console.log('📦 找到第三步的下一步按钮:', step3NextBtn);
    if (step3NextBtn) {
      step3NextBtn.addEventListener('click', () => {
        console.log('🖱️ 点击第三步的下一步按钮');
        if (!this.isCanShowCheckout()) {
          this.showCannotCheckoutDialog(true);
          return;
        }
        this.state.currentStep = 4;
        this.unlockStep();
      });
    }

    // 底部悬浮的步骤条
    this.state.stepSelectEl = document.getElementById('aipetProductStep_Select');

    // 监听关闭无法结账弹窗
    const cannotCheckoutCloseBtn = document.querySelector('.aipet-product-cannotcheckout-dialog-close');
    if (cannotCheckoutCloseBtn) {
      cannotCheckoutCloseBtn.addEventListener('click', () => {
        this.showCannotCheckoutDialog(false);
      });
    }

    this.initStep4Observer();

    this.initFQQuestionIconClick();

    console.log('✅ 事件绑定完成');
  }

  // ========== Step 1: 模型选择 ==========

  handleModelSelect(index) {
    const model = this.state.step1.models[index];
    if (!model) {
      console.error('❌ 模型不存在:', index);
      return;
    }

    console.log('✅ 选择模型:', model);

    const hadSelectedModel = this.state.step1.models.some(m => m.isSelected && m.variantId);

    // 更新状态
    this.state.step1.models.forEach((m, i) => {
      m.isSelected = i === index;
    });
    this.state.step1.selectedIndex = index;

    // 更新 UI
    this.state.step1Items.forEach((item, i) => {
      if (i === index) {
        item.classList.add('selected');
      } else {
        item.classList.remove('selected');
      }
    });

    // 保留原有的第一个配件显隐规则
    this.updateStep3GiftVisibility();

    // 根据活动配置和已选型号切换免费配件
    this.syncFreeAccessoryPromotion();

    // 从未选产品恢复为实际型号时，显示并自动选中免费套餐。
    this.syncFreePlanAvailability(!hadSelectedModel && !!model.variantId);

    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();

    // 更新图片
    // 这里是执行 根据变体id 产品图片展示不同的
    if(model?.variantId){
      MyCustomProductSliderConstructor.myProdSliderVariantForImg(model?.variantId)
    }

    // 更新预售日期
    // const saleDateEl = document.querySelector('.aipet-product-step1-saledate');
    // saleDateEl.classList.remove('active');
    // this.state.isPresale = true;
    // saleDateEl.classList.add('active');
    // this.state.presaleDate = '2026/02/16';
    // let saleDateElTextEl = saleDateEl.querySelector('.aipet-product-step1-saledate-text');
    // saleDateElTextEl.textContent = this.state.presaleDate;
    // let saleDateObj =  window.myCurrentProdPresaleConfigCustomObj[model?.variantId];
    // if(model?.variantId && window.productAvailable){
    //   // aipet-product-step1-saledate
    //   window.productObj.variants.forEach(variant => {
    //     if(variant.id.toString() === model?.variantId){
    //       console.log('预售的变体:', variant, variant.inventory_quantity);
    //       if(variant.available === true&& variant.inventory_quantity <= 0){
    //         let saleDateElTextEl = saleDateEl.querySelector('.aipet-product-step1-saledate-text');
    //         saleDateElTextEl&&(saleDateElTextEl.textContent = saleDateObj);
    //         saleDateEl.classList.add('active');
    //         this.state.isPresale = true;
    //         this.state.presaleDate = saleDateObj;
    //       }
    //     }
    //   });
    // }

    // 获取变体的积分展示
    if (model?.variantId) {
      getProductVariantPoint(model?.variantId);
    }
  }

  // 选择任一型号时展示第一个配件，选择「未選択」时隐藏。
  updateStep3GiftVisibility() {
    const firstAccessory = this.state.step3.accessories[0];
    const firstItem = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-item');
    if (!firstAccessory || !firstItem) return;

    const selectedModel = this.state.step1.models.find(model => model.isSelected);
    const hasVariant = !!selectedModel?.variantId;

    if (hasVariant) {
      firstItem.style.display = '';
    } else {
      firstItem.style.display = 'none';
      firstAccessory.isSelected = false;
      firstItem.classList.remove('selected');
    }

    this.syncStep3ButtonText();
  }

  // 通过原价变体 ID 定位活动配件，不依赖配件在列表中的位置。
  initFreeAccessoryPromotion(accessoryItems) {
    const rawConfig = window.aipetFreeAccessoryPromotion;
    if (!rawConfig || typeof rawConfig !== 'object') return;

    const config = {
      enabled: rawConfig.enabled === true,
      replacementVariantId: String(rawConfig.replacementVariantId || ''),
      freeVariantId: String(rawConfig.freeVariantId || ''),
      freePrice: Number(rawConfig.freePrice),
      eligibleModelVariantIds: Array.isArray(rawConfig.eligibleModelVariantIds)
        ? rawConfig.eligibleModelVariantIds.map(String)
        : [],
      badgeText: String(rawConfig.badgeText || 'プレゼント')
    };

    const accessory = this.state.step3.accessories.find(item => (
      String(item.variantId) === config.replacementVariantId
    ));
    const itemElement = Array.from(accessoryItems).find(item => (
      item.dataset.accessoryVariantId === config.replacementVariantId
    ));

    if (!accessory || !itemElement) {
      if (config.enabled) {
        console.warn('⚠️ 免费配件活动配置无法匹配到配件:', config.replacementVariantId);
      }
      return;
    }

    if (config.enabled && (
      !config.freeVariantId ||
      !Number.isFinite(config.freePrice) ||
      config.eligibleModelVariantIds.length === 0
    )) {
      console.warn('⚠️ 免费配件活动配置不完整，已保持原价配件行为');
      config.enabled = false;
    }

    const priceElement = itemElement.querySelector('.aipet-product-step3-item-price');
    this.freeAccessoryPromotionContext = {
      config,
      accessory,
      itemElement,
      priceElement,
      badgeElement: itemElement.querySelector('.aipet-product-step3-gift-badge'),
      originalVariantId: String(accessory.variantId),
      originalPrice: accessory.price,
      originalPriceText: priceElement?.textContent.trim() || `+${accessory.price.toLocaleString()}円`,
      isGiftActive: false
    };
  }

  syncFreeAccessoryPromotion() {
    const context = this.freeAccessoryPromotionContext;
    if (!context) return;

    const selectedModel = this.state.step1.models.find(model => model.isSelected);
    const selectedModelVariantId = String(selectedModel?.variantId || '');
    const shouldActivateGift = context.config.enabled &&
      context.config.eligibleModelVariantIds.includes(selectedModelVariantId);
    const wasGiftActive = context.isGiftActive;

    // 活动开启时，目标配件始终显示：符合条件时显示免费版，否则显示原价版。
    if (context.config.enabled) {
      context.itemElement.style.display = '';
    }

    if (shouldActivateGift) {
      context.accessory.variantId = context.config.freeVariantId;
      context.accessory.price = context.config.freePrice;
      context.accessory.quantity = 1;
      context.accessory.isSelected = true;
      context.accessory.locked = true;
      context.itemElement.classList.add('selected', 'is-free-gift');
      context.itemElement.dataset.currentVariantId = context.config.freeVariantId;
      if (context.priceElement) {
        context.priceElement.textContent = `${context.config.freePrice.toLocaleString()}円`;
      }
      if (context.badgeElement) {
        context.badgeElement.textContent = context.config.badgeText;
        context.badgeElement.setAttribute('aria-hidden', 'false');
      }
    } else {
      context.accessory.variantId = context.originalVariantId;
      context.accessory.price = context.originalPrice;
      context.accessory.locked = false;
      if (wasGiftActive) {
        context.accessory.isSelected = false;
      }
      context.itemElement.classList.remove('is-free-gift');
      context.itemElement.classList.toggle('selected', context.accessory.isSelected);
      context.itemElement.dataset.currentVariantId = context.originalVariantId;
      if (context.priceElement) {
        context.priceElement.textContent = context.originalPriceText;
      }
      if (context.badgeElement) {
        context.badgeElement.textContent = '';
        context.badgeElement.setAttribute('aria-hidden', 'true');
      }
    }

    context.isGiftActive = shouldActivateGift;
    this.syncStep3ButtonText();
  }

  syncStep3ButtonText() {
    const step3Btn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-btn');
    if (step3Btn) {
      const anySelected = this.state.step3.accessories.some(accessory => accessory.isSelected);
      step3Btn.textContent = anySelected ? '次へ進む' : '選択せずに次へ';
    }
  }

  // ========== Step 2: 套餐选择 ==========

  isPlanAvailable(plan) {
    return !plan.requiresModel || this.state.step1.models.some(model => model.isSelected && model.variantId);
  }

  syncFreePlanAvailability(autoSelect = false) {
    this.state.step2.plans.forEach((plan, index) => {
      if (!plan.requiresModel) return;

      const available = this.isPlanAvailable(plan);
      const item = this.state.step2Items[index];
      if (item) item.style.display = available ? '' : 'none';

      if (!available) {
        plan.isSelected = false;
        item?.classList.remove('selected');
      } else if (autoSelect) {
        this.handlePlanSelect(index);
      }
    });
  }

  handlePlanSelect(index) {
    const plan = this.state.step2.plans[index];
    if (!plan) {
      console.error('❌ 套餐不存在:', index);
      return;
    }
    if (!this.isPlanAvailable(plan)) return;

    console.log('✅ 切换套餐选择:', plan.name);

    // 先保存当前状态(用于回显)
    const previousState = JSON.parse(JSON.stringify(plan));

    // 切换选中状态
    plan.isSelected = !plan.isSelected;

    // 更新 currentVariantId
    const activeVariant = plan.variants.find(v => v.isActive);
    if (activeVariant) {
      plan.currentVariantId = activeVariant.variantId;
    }

    // 更新 UI
    this.state.step2Items.forEach((item, i) => {
      if (i !== index) {
        item.classList.remove('selected');
        this.state.step2.plans[i].isSelected = false;
      } else if (i === index) {
        item.classList.add('selected');
        this.state.step2.plans[i].isSelected = true;
      }
    });

    // 回显之前的状态(数量、月付/年付等)
    this.restorePlanUI(index, previousState);

    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();
  }

  // 回显套餐 UI 状态
  restorePlanUI(index, previousState) {
    const planItems = document.querySelectorAll('#aipetProductStep2_Plan .aipet-product-step2-item');
    const planItem = planItems[index];
    if (!planItem) return;

    const plan = this.state.step2.plans[index];

    // 回显数量
    const input = planItem.querySelector(`#aipet-product-step2-item-input${index}`);
    if (input) {
      input.value = plan.quantity;
    }

    // 回显月付/年付
    if (plan.variants.length > 1) {
      const monthBtn = planItem.querySelector('.aipet-product-step2-item-middle-top-right-month');
      const yearBtn = planItem.querySelector('.aipet-product-step2-item-middle-top-right-year');
      
      const activeVariant = plan.variants.find(v => v.isActive);
      if (activeVariant) {
        if (activeVariant.type === 'month') {
          monthBtn?.classList.add('active');
          yearBtn?.classList.remove('active');
        } else if (activeVariant.type === 'year') {
          yearBtn?.classList.add('active');
          monthBtn?.classList.remove('active');
        }

        // 更新价格显示
        const priceElement = planItem.querySelector('.aipet-product-step2-item-middle-price');
        if (priceElement) {
          const unit = activeVariant.type === 'month' ? '月' : '年';
          priceElement.textContent = `￥${activeVariant.price.toLocaleString()} / ${unit}`;
        }
      }
    }

    // 回显合计
    this.updatePlanTotal(index);

    console.log('🔄 已回显状态:', plan);
  }

  handlePlanTypeChange(btn) {
    const planItem = btn.closest('.aipet-product-step2-item');
    const planIndex = Array.from(planItem.parentElement.children).indexOf(planItem);
    const plan = this.state.step2.plans[planIndex];
    
    if (!plan || plan.variants.length <= 1) return;

    const isMonth = btn.classList.contains('aipet-product-step2-item-middle-top-right-month');
    const targetType = isMonth ? 'month' : 'year';

    console.log('🔄 切换套餐类型:', targetType);

    // 更新状态
    plan.variants.forEach(variant => {
      variant.isActive = variant.type === targetType;
      if (variant.isActive) {
        plan.currentVariantId = variant.variantId;
      }
    });

    // 更新 UI
    const monthBtn = planItem.querySelector('.aipet-product-step2-item-middle-top-right-month');
    const yearBtn = planItem.querySelector('.aipet-product-step2-item-middle-top-right-year');
    
    if (isMonth) {
      monthBtn?.classList.add('active');
      yearBtn?.classList.remove('active');
    } else {
      yearBtn?.classList.add('active');
      monthBtn?.classList.remove('active');
    }

    // 更新价格显示
    const activeVariant = plan.variants.find(v => v.isActive);
    if (activeVariant) {
      const priceElement = planItem.querySelector('.aipet-product-step2-item-middle-price');
      if (priceElement) {
        const unit = activeVariant.type === 'month' ? '月' : '年';
        priceElement.textContent = `￥${activeVariant.price.toLocaleString()} / ${unit}`;
      }
    }
    // 更新标题显示
    const titleElement = planItem.querySelector('.aipet-product-step2-item-middle-top-title');
    titleElement.textContent = isMonth ? `${plan.name}（月額）` : `${plan.name}（年額）`;
    //  计算当前的套餐合计
    this.updatePlanTotal(planIndex);
    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();
  }

  handleQuantityChange(planIndex, action) {
    console.log(`🔢 调整套餐 ${planIndex} 数量: ${action}`);
    const plan = this.state.step2.plans[planIndex];
    if (!plan) return;

    const input = document.querySelector(`#aipet-product-step2-item-input${planIndex}`);
    let value = parseInt(input?.value) || 1;

    if (action === 'plus' && value < this.state.inputMax) {
      value++;
    } else if (action === 'minus' && value > 1) {
      value--;
    }

    console.log('🔢 调整数量:', value);

    if (input) input.value = value;
    plan.quantity = value;

    this.updatePlanTotal(planIndex);
    this.calculateTotal();
    this.updateCheckoutContent();
    this.updateStepSummary();
  }

  // 更新套餐合计显示
  updatePlanTotal(planIndex) {
    const plan = this.state.step2.plans[planIndex];
    const activeVariant = plan.variants.find(v => v.isActive);
    
    if (activeVariant) {
      const planItems = document.querySelectorAll('#aipetProductStep2_Plan .aipet-product-step2-item');
      const hjElement = planItems[planIndex]?.querySelector('.aipet-product-step2-item-middle-num-hj');
      
      if (hjElement && plan.quantity >= 1) {
        let isMonthly = activeVariant.type === 'month';
        let isYear = activeVariant.type === 'year';
        let isYearService = activeVariant.type === 'yearService';
        let totalPrice = 0;
        let monthNum = 1;
        if (isYear) {
          totalPrice = activeVariant.price * plan.quantity;
          monthNum = plan.quantity * 12;
        } else if (isMonthly) {
          totalPrice = activeVariant.price * plan.quantity;
          monthNum = plan.quantity;
        } else if (isYearService) {
          totalPrice = activeVariant.price * plan.quantity;
          monthNum = plan.quantity * 12;
        }
        hjElement.textContent = `合計(${monthNum}ヶ月分):¥${totalPrice.toLocaleString()}`;
      } else if (hjElement) {
        hjElement.textContent = '';
      }
    }
  }

  // ========== Step 3: 配件选择 (已注释) ==========

  // handleAccessorySelect(index) {
  //   const accessory = this.state.step3.accessories[index];
  //   if (!accessory) return;

  //   console.log('🖱️ 选择配件:', accessory);

  //   // 切换选中状态
  //   accessory.isSelected = !accessory.isSelected;
  //   
  //   // 选中时数量默认为 1,取消时为 0
  //   if (accessory.isSelected && accessory.quantity === 0) {
  //     accessory.quantity = 1;
  //   } else if (!accessory.isSelected) {
  //     accessory.quantity = 0;
  //   }

  //   // 更新 UI
  //   const accessoryItems = document.querySelectorAll('#aipetProductStep3_Cloth .aipet-product-step3-item');
  //   const item = accessoryItems[index];
  //   
  //   if (accessory.isSelected) {
  //     item?.classList.add('selected');
  //   } else {
  //     item?.classList.remove('selected');
  //   }

  //   // 更新next按钮状态
  //   const step3NextBtn = document.querySelector('#aipetProductStep3_Cloth .aipet-product-step3-btn');
  //   if (this.state.step3.accessories.some(acc => acc.isSelected)) {
  //     step3NextBtn.textContent = '次へ進む';
  //   } else {
  //     step3NextBtn.textContent = '選択せずに次へ';
  //   }

  //   // 更新数量显示
  //   // const input = item?.querySelector('.aipet-product-step3-item-quantity');
  //   // if (input) {
  //   //   input.value = accessory.quantity;
  //   // }

  //   this.calculateTotal();
  //   this.updateCheckoutContent();
  //   this.updateStepSummary();
  // }

  // ========== 计算总价 ==========
  calculateTotal() {
    let total = 0;

    // Step 1: 模型价格
    if (this.state.step1.selectedIndex !== null) {
      const selectedModel = this.state.step1.models[this.state.step1.selectedIndex];
      if (selectedModel) {
        total += selectedModel.price;
      }
    }

    // Step 2: 套餐价格
    this.state.step2.plans.forEach(plan => {
      if (plan.isSelected) {
        const activeVariant = plan.variants.find(v => v.isActive);
        if (activeVariant) {
          total += activeVariant.price * plan.quantity;
        }
      }
    });

    // Step 3: 配件价格
    this.state.step3.accessories.forEach(accessory => {
      if (accessory.isSelected) {
        total += accessory.price * accessory.quantity;
      }
    });

    this.state.step4.totalPrice = total;
    // this.updateTotalDisplay();
    console.log('💰 总价:', total);
  }

  // 根据步骤解除遮罩
  unlockStep() {
    // 解锁当前步骤
    const stepIds = [
    'aipetProductStep1_Main',
    'aipetProductStep2_Plan',
    'aipetProductStep3_Cloth',
    'aipetProductStep4_Overview'
  ];
    let stepNumber = this.state.currentStep;
    const currentStepEl = document.getElementById(stepIds[stepNumber - 1]);
    currentStepEl.classList.remove('aipet-product-step-mask');
    currentStepEl.classList.add('active');
    
    // 遮罩后续步骤
    for (let i = stepNumber; i < stepIds.length; i++) {
      const el = document.getElementById(stepIds[i]);
      el&&el.classList.add('aipet-product-step-mask');
      el&&el.classList.remove('active');
    }
    // 显示底部摘要
    if (this.state.stepSelectEl && this.state.step1.selectedIndex !== null) {
      this.state.stepSelectEl.classList.add('show');
    }

    this.updateStepIndicators();

    // 滚动到当前步骤
    setTimeout(() => {
      this.scrollToStepElement(currentStepEl);
    }, 200);

  }

  // 每次变化都需要更新底部摘要
  updateStepSummary() {
    if (!this.state.stepSelectEl) return;

    // 更新模型信息
    const step1 = this.state.step1.models.find(m => m.isSelected);
    if (step1 && step1.title) {
      console.log('🔄 updateStepSummary 更新结账模型信息:', step1);
      const leftImg = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-left img');
      const titleEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-left .aipet-product-step-selectwrap-left-title');
      if (leftImg) leftImg.src = step1.image;
      if (titleEl) titleEl.textContent = step1.title;
    }
    
    // 更新计划信息
    const step2 = this.state.step2.plans.find(p => p.isSelected);
    const planEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-middle  .aipet-product-step-selectwrap-select2');
    if (step2 && step2.name) {
      console.log('🔄 更新结账计划的信息:', step2);
      if (planEl) {
        if(step2.variantId){
          planEl.textContent = `${step2.name} x ${step2.quantity}`;
        } else {
          planEl.textContent = step2.name;
        }
      }
    } else if (planEl) {
      planEl.textContent = '';
    }
    
    // 更新配件信息
    let step3Items = [];
    this.state?.step3?.accessories.forEach(accessory => {
      if (accessory.isSelected) {
        step3Items.push(accessory.title);
      }
    });
    const accEl = this.state.stepSelectEl?.querySelector('.aipet-product-step-selectwrap-middle .aipet-product-step-selectwrap-select3');
    if (accEl) {
      accEl.textContent = step3Items.length > 0 ? step3Items.join(' + ') : '';
    }

    // 更新总价
    const hjPriceEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-right  .aipet-product-step-selectwrap-hj-price');
    if (hjPriceEl) {
      hjPriceEl.textContent = `￥${this.state.step4.totalPrice.toLocaleString()}（税込）`;
    }

    // 更新 预计发货日期？？？
    let psDateStr =  getMyProductEstimatedStrFn();
    const estDateEl = this.state.stepSelectEl.querySelector('.aipet-product-step-selectwrap-ps-date');
    estDateEl&&(estDateEl.textContent = (this.state.isPresale ? this.state.presaleDate  : psDateStr) || '30営業日以内出荷');

    this.updateStepIndicators();
  }
  // 更新步骤指示器
  updateStepIndicators() {
    const steps = document.querySelectorAll('.aipet-product-step-selectwrap-stepswrap > div');
    steps.forEach((step, index) => {
      console.log('🔄 更新步骤指示器:', index, this.state.currentStep);
      if (index < this.state.currentStep - 1) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });
  }

  // 每次变化都需要更新第四部的总览结账内容
  updateCheckoutContent() {
    const checkoutEle = document.getElementById('aipetProductStep4_Overview');
    this.state.checkoutEle = checkoutEle;
    if (!checkoutEle) return;

    // 更新 模型的图片 标题 价格
    // aipet-product-step4-selectitem pet
    // aipet-product-step4-selectitem-left > img
    // aipet-product-step4-selectitem-title
    // aipet-product-step4-selectitem-price
    const step1 = this.state.step1.models.find(m => m.isSelected);
    if (step1 && step1.title) {
      console.log('🔄 更新结账模型信息:', step1);
      const leftImg = checkoutEle.querySelector('.aipet-product-step4-selectitem.pet > .aipet-product-step4-selectitem-left img');
      const titleEl = checkoutEle.querySelector('.aipet-product-step4-selectitem.pet  .aipet-product-step4-selectitem-title');
      const priceEl = checkoutEle.querySelector('.aipet-product-step4-selectitem.pet  .aipet-product-step4-selectitem-price');
      if (leftImg) leftImg.src = step1.image;
      if (titleEl) titleEl.textContent = step1.title;
      if (priceEl) priceEl.textContent = `￥${step1.price.toLocaleString()}`;
    }

    // 更新 第二步的 计划的 标题 价格 数量 合计
    // aipet-product-step4-selectitem plan
    // aipet-product-step4-selectitem-left
    // aipet-product-step4-selectitem-right
    const step2 = this.state.step2.plans.find(p => p.isSelected);
    const planRow = checkoutEle.querySelector('.aipet-product-step4-selectitem.plan');
    const leftEl = checkoutEle.querySelector('.aipet-product-step4-selectitem.plan > .aipet-product-step4-selectitem-left');
    const rightEl = checkoutEle.querySelector('.aipet-product-step4-selectitem.plan > .aipet-product-step4-selectitem-right');
    if (planRow) planRow.style.display = step2 ? '' : 'none';
    if (step2 && step2.name) {
      console.log('🔄 更新结账计划的信息:', step2);
      if (leftEl) leftEl.textContent = `${step2.name}`;
      if (rightEl) {
        const activeVariant = step2.variants.find(v => v.isActive);
        let unit = '';
        const allPrice = activeVariant.price * step2.quantity;
        if (activeVariant) {
          if (activeVariant.type === 'month') {
            unit = '月';
            rightEl.textContent = `￥${allPrice.toLocaleString()} /  ${step2.quantity}${unit}`;
          } else if (activeVariant.type === 'year') {
            unit = '年';
            rightEl.textContent = `￥${allPrice.toLocaleString()} /  ${step2.quantity}${unit}`;
          } else if (activeVariant.type === 'yearService') {
            unit = '年';
            rightEl.textContent = `￥${allPrice.toLocaleString()} /  ${step2.quantity}${unit}`;
          } else {
            unit = '';
            rightEl.textContent = `￥${allPrice.toLocaleString()}`;
          }
        }
      }
    } else {
      if (leftEl) leftEl.textContent = '';
      if (rightEl) rightEl.textContent = '';
    }

    // 更新 第三步的 配件的 标题 价格 
    // aipet-product-step4-selectitem-cloth
    // aipet-product-step4-selectitem cloth
    // aipet-product-step4-selectitem-left
    // aipet-product-step4-selectitem-right
    const step3 = this.state?.step3?.accessories.filter(a => a.isSelected);
    console.log('🔄 更新结账配件的信息:', step3);
    if (step3 && step3.length > 0) {
      const clothEl = checkoutEle.querySelector('.aipet-product-step4-selectitem-cloth');
      if (clothEl) {
        // 清空之前的内容
        clothEl.innerHTML = '';
        step3.forEach(accessory => {
          const accDiv = document.createElement('div');
          accDiv.classList.add('aipet-product-step4-selectitem', 'cloth');
          accDiv.innerHTML = `
            <div class="aipet-product-step4-selectitem-left">${accessory.title}</div>
            <div class="aipet-product-step4-selectitem-right">￥${(accessory.price * accessory.quantity).toLocaleString()}</div>
          `;
          clothEl.appendChild(accDiv);
        });
      }
    } else {
      // 如果没有选择配件，清空内容
      const clothEl = checkoutEle.querySelector('.aipet-product-step4-selectitem-cloth');
      if (clothEl) {
        clothEl.innerHTML = '';
      }
    }

    // 更新 总价
    // aipet-product-step4-select-hj
    // aipet-product-step4-select-hj-price
    const hjPriceEl = checkoutEle.querySelector('.aipet-product-step4-select-hj-price');
    if (hjPriceEl) {
      hjPriceEl.textContent = `￥${this.state.step4.totalPrice.toLocaleString()}`;
    }
    this.updateFQAmount(this.state.step4.totalPrice); // 更新分期金额显示
    
    // 更新 结账按钮事件 尝试 a 标签结账
    // aipet-product-checkout-btn
    const checkoutBtn = checkoutEle.querySelector('.aipet-product-checkout-btn > a');
    if (checkoutBtn) {
      let ahref = '';
      const items = [];
      // Step 1: 模型
      if (this.state.step1.selectedIndex !== null) {
        const selectedModel = this.state.step1.models[this.state.step1.selectedIndex];
        if (selectedModel && selectedModel.variantId) {
          items.push(`${selectedModel.variantId}:1`);
        }
      }

      // Step 2: 套餐
      this.state.step2.plans.forEach(plan => {
        if (plan.isSelected && plan.currentVariantId) {
          items.push(`${plan.currentVariantId}:${plan.quantity}`);
        }
      });
      // Step 3: 配件
      this.state?.step3?.accessories.forEach(accessory => {
        if (accessory.isSelected && accessory.quantity > 0) {
          items.push(`${accessory.variantId}:${accessory.quantity}`);
        }
      });

      if (items.length > 0) {
        ahref = `/cart/${items.join(',')}`;
      } else {
        ahref = '#';
      }
      console.log('🔗 更新结账链接:', ahref);
      checkoutBtn.href = ahref;
      checkoutBtn.onclick = null;
      checkoutBtn.addEventListener('click', function handler() {
        checkoutBtn.closest('.aipet-product-checkout-btn').classList.add('loading');
      }, { once: true });
    }
    
    // 更新 预计发货日期？？？
    let psDateStr =  getMyProductEstimatedStrFn();
    console.log('🔄 预计发货日期:', psDateStr);
    const estDateEl = checkoutEle.querySelector('.aipet-product-step4-select-ps-date');
    estDateEl&&(estDateEl.textContent = (this.state.isPresale ? this.state.presaleDate : psDateStr) || '30営業日以内出荷');
  }

  // 滚动到指定步骤元素
  scrollToStepElement(stepElement) {
    if (!stepElement) {
      console.log('scrollToStepElement: stepElement is null');
      return;
    }
    
    console.log('scrollToStepElement called for:', stepElement.id);
    
    const isMobile = window.innerWidth <= 767;
    console.log('isMobile:', isMobile);
    
    // 先尝试查找所有可能的滚动容器
    const infoWrap = document.querySelector('.aipet-product-content-infowrap');
    const rightContent = document.querySelector('.aipet-product-content-right');
    const productMain = document.querySelector('.aipet-product-main');
    
    console.log('infoWrap found:', !!infoWrap);
    console.log('rightContent found:', !!rightContent);
    console.log('productMain found:', !!productMain);
    
    const offset = 20; // 标题上方预留空间
    // 方法2: 尝试滚动 window
    console.log('Method 2: Scrolling window');
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const elementTop = stepElement.getBoundingClientRect().top + window.pageYOffset;
    const scrollPosition = elementTop - headerHeight - offset;
    
    
    window.scrollTo({
      top: Math.max(0, scrollPosition),
      behavior: 'smooth'
    });
  }

  // 监听第4步（总览）的可见性，控制底部摘要显示
  initStep4Observer() {
    const step4 = document.getElementById('aipetProductStep4_Overview');
    
    if (!step4 || !this.state.stepSelectEl) return;
    
    // 创建 IntersectionObserver 来监听第4步是否进入视窗
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 检查第4步是否还有遮罩（未解锁）
          const step4HasMask = step4.classList.contains('aipet-product-step-mask');
          
          // 检查第3步是否有选择内容（step3 是否进行了选择）
          const step3HasSelection = this.state?.step3?.accessories.some(accessory => accessory.isSelected && accessory.quantity > 0);
          
          // 如果第4步有遮罩，或者第3步还没有选择，则保持显示底部摘要
          if (step4HasMask || !step3HasSelection) {
            if (this.state.currentStep > 1) {
              this.state.stepSelectEl.classList.add('show');
              this.state.stepSelectEl.classList.remove('hide');
            }
          } else {
            // 第4步已解锁且第3步有选择，隐藏底部摘要
            this.state.stepSelectEl.classList.remove('show');
            this.state.stepSelectEl.classList.add('hide');
          }
        } else {
          // 第4步离开视窗，且当前步骤大于1时显示底部摘要
          if (this.state.currentStep > 1) {
            this.state.stepSelectEl.classList.add('show');
            this.state.stepSelectEl.classList.remove('hide');
          }
        }
      });
    }, {
      threshold: 0.1, // 当10%的第4步进入视窗时触发
      rootMargin: '-50px 0px -50px 0px' // 调整触发区域
    });
    
    observer.observe(step4);
  }

  // 检查是否可以显示结账 需要至少选择一个套餐
  isCanShowCheckout() {
    let step1Selected = this.state.step1.models.some(model => model.isSelected && model.variantId);
    let step2Selected = this.state.step2.plans.some(plan => plan.isSelected && plan.currentVariantId);
    let step3Selected = this.state?.step3?.accessories.some(accessory => accessory.isSelected && accessory.quantity > 0);
    console.log('🔍 检查是否可以显示结账:', { step1Selected, step2Selected, step3Selected });
    if (step1Selected || step2Selected || step3Selected) {
      return true;
    } else {
      return false;
    }
  }
  // 显示无法结账的提示弹窗
  showCannotCheckoutDialog(show) {
    let dialog = document.querySelector('.aipet-product-cannotcheckout-dialog');
    dialog&&dialog.classList.toggle('active', show);
  }

  // 监听分期的问号icon的点击
  initFQQuestionIconClick() {
    const icon = document.getElementById('aipet-product-fq-content-money-question');
    if (icon) {
      icon.addEventListener('click', () => {
        let fqCont = document.querySelector('.aipet-product-cannotcheckout-dialog-content');
        if (fqCont) {
          let contEle = fqCont.querySelector('div');
          contEle.innerHTML = `分割手数料はカード会社やお支払い回数により異なります。<br/>詳しくはご利用のカード会社へご確認ください。`;
        }
        this.showCannotCheckoutDialog(true);
      });
    }
  }
  // 合计变化，更新分期的金额
  updateFQAmount(price) {
    const fqAmountEl = document.getElementById('aipet-product-fq-content-money-amount');
    if (fqAmountEl) {
      price = Math.ceil((price || 0) / 36);
      fqAmountEl.textContent = price.toLocaleString() + '円';
    }
  }


  // ========== 调试工具 ==========
  printState() {
    console.log('📊 当前状态:', this.state);
  }
}

// ========== 初始化 ==========
let aipetManager;

function initAipetManager() {
  aipetManager = new AipetProductManager();
  window.aipetManager = aipetManager;
  console.log('✅ AipetProductManager 已初始化');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAipetManager);
} else {
  initAipetManager();
}


/* 这里是 弹窗图片的代码 */
// 点击 弹窗的图片 开始 类型 compare plan
let aipetGBObj = {
  isMbUI: false,
  // 首先存着产品 变体的数据，特别是多个产品
  // 要存所有的步骤，每个步骤的选项，和每个选项的价格 key
  // 要存当前的步骤，和已经选择的选项
  // 
}
const myAipetDialogImgClick = (type) => {
  if (!type) return;
  myAipetDialogImgClose(true);
  if (type === 'plan') {
    if (aipetGBObj.isMbUI){
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/2x_2_4a7c9401-4b54-48ab-b8dd-eac00de47bcd.webp?v=1769408342');
    } else {
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/2x_1_171f8070-6cd4-4d5b-b1cc-6f4e09fe1aaa.webp?v=1769408342');
    }
  } else if (type === 'compare') {
    if (aipetGBObj.isMbUI){
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/2x_0da0c604-4f58-41b8-a491-86231e6dccf3.webp?v=1769408341');
    } else {
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/2x_1_09d004c7-b169-4d80-8977-011e3538e183.webp?v=1769408342');
    }
  } else if (type === 'card_kumamon') {
    if (aipetGBObj.isMbUI){
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/M_1.5x_139b7e48-c8e8-4a42-8c21-797691987386.webp?v=1789526058');
    } else {
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/1.5x_c9753bd0-27e9-4433-91b4-c06b5e92a226.webp?v=1789525973');
    }
  } else if (type === 'card_niko') {
    if (aipetGBObj.isMbUI){
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/M_2x_7be480e7-c207-4fd3-8357-ac5647f2e97f.webp?v=1769674361');
    } else {
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/Niko_3x_9d042dd4-20d2-4d24-bdae-e4e75ab9dab7.webp?v=1769419396');
    }
  } else if (type === 'card_noa') {
    if (aipetGBObj.isMbUI){
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/M_2x_3e7bcf54-1108-4271-bf4c-e520b10623ec.webp?v=1769674361');
    } else {
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/Noa_3x_fe644c6e-6ec3-4afe-bc4a-d15ab0befad6.webp?v=1769419396');
    }
  } else if (type === 'setp2_free') {
    if (aipetGBObj.isMbUI){
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/4255_3x_2d31a7ce-fe57-4480-963e-c8db65d52e04.webp?v=1789545065');
    } else {
      $('#myCustomAipetDilaogImg').attr('src', 'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/4401_3x_918891cd-ca05-451a-8c72-f5ad88a30de6.webp?v=1789539877');
    }
  }

}
const myAipetDialogImgClose = (flag) => {
  if (flag) {
    $('.aipet-product-dialog-imgwrap').addClass('active');
  } else {
    $('.aipet-product-dialog-imgwrap').removeClass('active');
  }
}
/* 这里是 弹窗图片的代码 end */

// 获取预计送达的时间
function getMyProductEstimatedStrFn() {
    let dateStr = ''
    let myDate = new Date()
    let myYMD = myDate.toLocaleDateString() // '2023/10/11'
    let myZJ = myDate.getDay() > 0 ? myDate.getDay() : '7'
    let myHour = myDate.getHours()
    let addDayFn = function (day) {
        // console.log(day, '算 几天后')

        let ndd = new Date()
        ndd.setDate(ndd.getDate() + day)
        // console.log(ndd, 'ndd 复制几天后')
        let yy = ndd.getFullYear()
        let mm = ndd.getMonth() < 9 ? '0' + (ndd.getMonth() + 1) : (ndd.getMonth() + 1)
        let d = ndd.getDate() < 10 ? '0' + ndd.getDate() : ndd.getDate()
        // console.log(yy, mm, d, 'yy, mm, d')

        return yy + '/' + mm + '/' + d
    }
    // 如果是周五-周日
    if (myZJ - 5 >= 0) {
        let num = 7 - myZJ + 1
        dateStr = addDayFn(num)
    } else {
        // 周一到周四
        dateStr = addDayFn(1)
    }
    return dateStr
}

// 监听根据变体id 更换 变体的积分
function getProductVariantPoint(variantId) {
    let noSHowProductToPointArr = [''];
    let myProductId = window.productId;
    console.log(noSHowProductToPointArr, 'noSHowProductToPointArr', myProductId, 'myProductId');
    if (noSHowProductToPointArr.includes(myProductId)) {
        $('.my-product-price-point-wrap').css('display', 'none');
        return;
    }
    const pointPerUnit = 4
    let myProductVariantPointId = document.getElementById('myProductVariantPointId')
    // console.log(myProductVariantPointId, 'myProductSaveVariantPointId')

    let myProductVariantPointMoneyNode = document.getElementById('myProductVariantPointMoney')
    myProductVariantPointMoneyNode.innerHTML = '2800'

    let myvariantId = ''
    if (variantId) {
        myvariantId = variantId
    }

    if (myvariantId) {
        let myProductSaveVariantPointIdNode = document.getElementById('myProductSaveVariantPointId')
        let myProductSaveVariantNodes = myProductSaveVariantPointIdNode.getElementsByTagName("div")
        console.log(myProductSaveVariantPointIdNode, myProductSaveVariantNodes, 'myProductVariantPointIdNode.chidrenNode')
        myProductSaveVariantNodes = Array.from(myProductSaveVariantNodes);
        if (myProductSaveVariantNodes.length && myProductVariantPointId && myProductVariantPointMoneyNode) {
            myProductSaveVariantNodes.forEach(item => {
                console.log(item)
                let str = item.innerHTML
                let strArr = str.split(':')
                console.log(strArr, 'strArr')
                if (strArr[0] === myvariantId) {
                    myProductVariantPointId.innerHTML = strArr[1]
                    let pointMoney = (strArr[1] * pointPerUnit).toLocaleString()
                    myProductVariantPointMoneyNode.innerHTML = pointMoney
                }
            })
        }
    } else {
        let moneyNum = myProductVariantPointId.innerHTML
        let pointMoney = (moneyNum * pointPerUnit).toLocaleString()
        myProductVariantPointMoneyNode.innerHTML = pointMoney
    }
}

function myCustomInit() {
  if (window.screen.width <= 767) {
    aipetGBObj.isMbUI = true;
    document.querySelector('.aipet-product-content-infowrap-pcshow').innerHTML = ''
  } else {
    aipetGBObj.isMbUI = false;
    document.querySelector('.aipet-product-content-infowrap-mbshow').innerHTML = ''
  }
  window.productObj?.variants?.[0]?.id && getProductVariantPoint(window.productObj?.variants?.[0]?.id);
}
document.addEventListener('DOMContentLoaded', myCustomInit);

/* 第三步配件放大镜弹窗 & 轮播 */
// ノア variantId: '46499343761583' = 白娃 (noa)
// ニコ variantId: '46499343794351' = 灰娃 (niko)
const clothImagesData = {
  cloth_0: {
    noa: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3_4cedfe7b-bdef-44c9-be78-18359be62384.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4_1e505b53-cedb-446d-94ce-58b515d7e0e7.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5_708cb82a-0e77-4e7f-a892-86d74157d41f.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6_5a3327ad-3803-488b-897f-5ada13b3f7ab.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_90a54191-f437-40be-986e-1358e7dfe34a.webp?v=1779780665',
    ],
    niko: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1_99f83b06-2654-4afe-ac3e-b0ac11cab045.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2_b315a0f9-ecec-4a0d-9271-15e795504bce.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_90a54191-f437-40be-986e-1358e7dfe34a.webp?v=1779780665',
    ],
    all: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_90a54191-f437-40be-986e-1358e7dfe34a.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1_99f83b06-2654-4afe-ac3e-b0ac11cab045.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2_b315a0f9-ecec-4a0d-9271-15e795504bce.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3_4cedfe7b-bdef-44c9-be78-18359be62384.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4_1e505b53-cedb-446d-94ce-58b515d7e0e7.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5_708cb82a-0e77-4e7f-a892-86d74157d41f.webp?v=1779780665',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6_5a3327ad-3803-488b-897f-5ada13b3f7ab.webp?v=1779780665'
    ]
  },
  cloth_1: {
    noa: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1_8ca37c91-91c8-433f-952b-e8a0a3ff5b8c.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2_6225d377-b723-4619-9013-2b8cae5b2b0f.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_fb6b5628-453c-4ee3-ba4b-abd56d2b811d.webp?v=1779780638',
    ],
    niko: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3_603c93d7-83b4-4d8d-9b44-4e28882ad99d.webp?v=1779780639',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4_b0520aa1-6922-4038-85ca-f0d20e26c413.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5_f3405103-a2ed-409c-96b9-5407b88ba077.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6_7d44e8ce-0b03-4497-9302-81f6f3415c02.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_fb6b5628-453c-4ee3-ba4b-abd56d2b811d.webp?v=1779780638',
    ],
    all: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_fb6b5628-453c-4ee3-ba4b-abd56d2b811d.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1_8ca37c91-91c8-433f-952b-e8a0a3ff5b8c.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2_6225d377-b723-4619-9013-2b8cae5b2b0f.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3_603c93d7-83b4-4d8d-9b44-4e28882ad99d.webp?v=1779780639',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4_b0520aa1-6922-4038-85ca-f0d20e26c413.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5_f3405103-a2ed-409c-96b9-5407b88ba077.webp?v=1779780638',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6_7d44e8ce-0b03-4497-9302-81f6f3415c02.webp?v=1779780638'
    ]
  },
  cloth_2: {
    noa: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3_f324b907-63a0-4ba4-a7a3-e6ef2bd65fa2.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4_7fef2a7c-59e2-43cf-8246-564480586256.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5_6bbb37d7-52ca-4189-b1fc-3d9766be126c.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6_c0178b2b-a3f9-4744-b201-71dd6539c98d.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_30b09092-fd31-43a6-95c9-b6a37e502bec.webp?v=1779780597',
    ],
    niko: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1_0c762ffd-7d6e-4227-aa6d-a35d2f3fbfab.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2_85552b39-28d1-4a29-8da8-1bee3aea4cd2.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_30b09092-fd31-43a6-95c9-b6a37e502bec.webp?v=1779780597',
    ],
    all: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500_30b09092-fd31-43a6-95c9-b6a37e502bec.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1_0c762ffd-7d6e-4227-aa6d-a35d2f3fbfab.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2_85552b39-28d1-4a29-8da8-1bee3aea4cd2.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3_f324b907-63a0-4ba4-a7a3-e6ef2bd65fa2.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4_7fef2a7c-59e2-43cf-8246-564480586256.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5_6bbb37d7-52ca-4189-b1fc-3d9766be126c.webp?v=1779780597',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6_c0178b2b-a3f9-4744-b201-71dd6539c98d.webp?v=1779780597'
    ]
  },
  cloth_3: {
    noa: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500.webp?v=1779778933',
    ],
    niko: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5.webp?v=1779778933',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500.webp?v=1779778933',
    ],
    all: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500.webp?v=1779778933',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-1.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-2.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-3.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-4.webp?v=1779778934',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-5.webp?v=1779778933',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-_-1500X1500-6.webp?v=1779778934'
    ]
  },
  cloth_4: {
    noa: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-3.webp?v=1779778839',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-4.webp?v=1779778836',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-5.webp?v=1779778836',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-6.webp?v=1779778835',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500.webp?v=1779778835',
    ],
    niko: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-1.webp?v=1779778835',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-2.webp?v=1779778835',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500.webp?v=1779778835',
    ],
    all: [
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500.webp?v=1779778835',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-1.webp?v=1779778835',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-2.webp?v=1779778835',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-3.webp?v=1779778839',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-4.webp?v=1779778836',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-5.webp?v=1779778836',
      'https://cdn.shopify.com/s/files/1/0522/2458/9999/files/KATAFriends_-1500X1500-6.webp?v=1779778835'
    ]
  }
};

let clothSliderState = { currentIndex: 0, total: 0 };

function openClothDialog(type) {
  const data = clothImagesData[type];
  if (!data) return;

  // Filter images based on selected model (ノア=白娃 noa, ニコ=灰娃 niko, unselected=all)
  const selectedModel = window.aipetManager?.state?.step1?.models?.find(m => m.isSelected);
  let images;
  if (selectedModel?.variantId === '46499343761583') {
    images = data.noa;
  } else if (selectedModel?.variantId === '46499343794351') {
    images = data.niko;
  } else {
    images = data.all;
  }
  if (!images || !images.length) return;

  const dialog = document.querySelector('.aipet-product-cloth-dialog');
  if (!dialog) return;

  const track = dialog.querySelector('.aipet-product-cloth-slider-track');
  const dotsEl = dialog.querySelector('.aipet-product-cloth-slider-dots');

  track.innerHTML = images.map(src =>
    `<div class="aipet-product-cloth-slider-item"><img src="${src}" alt="" loading="lazy" /></div>`
  ).join('');

  dotsEl.innerHTML = images.map((src, i) =>
    `<img class="aipet-product-cloth-slider-dot${i === 0 ? ' active' : ''}" src="${src}" data-index="${i}" alt="" loading="lazy" />`
  ).join('');

  dotsEl.querySelectorAll('.aipet-product-cloth-slider-dot').forEach(dot => {
    dot.addEventListener('click', () => clothSliderGoTo(parseInt(dot.dataset.index)));
  });

  clothSliderState = { currentIndex: 0, total: images.length };
  clothSliderGoTo(0);

  const prevBtn = dialog.querySelector('.aipet-product-cloth-slider-prev');
  const nextBtn = dialog.querySelector('.aipet-product-cloth-slider-next');
  if (images.length <= 1) {
    prevBtn && (prevBtn.style.display = 'none');
    nextBtn && (nextBtn.style.display = 'none');
    dotsEl.style.display = 'none';
  } else {
    prevBtn && (prevBtn.style.display = 'flex');
    nextBtn && (nextBtn.style.display = 'flex');
    dotsEl.style.display = 'flex';
  }

  dialog.classList.add('active');
}

function clothSliderGoTo(index) {
  const dialog = document.querySelector('.aipet-product-cloth-dialog');
  if (!dialog) return;
  const track = dialog.querySelector('.aipet-product-cloth-slider-track');
  clothSliderState.currentIndex = index;
  track.style.transform = `translateX(-${index * 100}%)`;
  dialog.querySelectorAll('.aipet-product-cloth-slider-dot').forEach((dot, i) => {
    dot.classList.toggle('active', i === index);
  });
  const prevBtn = dialog.querySelector('.aipet-product-cloth-slider-prev');
  const nextBtn = dialog.querySelector('.aipet-product-cloth-slider-next');
  if (prevBtn) prevBtn.style.opacity = index === 0 ? '0.3' : '1';
  if (nextBtn) nextBtn.style.opacity = index === clothSliderState.total - 1 ? '0.3' : '1';
}

function closeClothDialog() {
  document.querySelector('.aipet-product-cloth-dialog')?.classList.remove('active');
}

document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('.aipet-product-cloth-dialog');
  if (!dialog) return;
  dialog.querySelector('.aipet-product-cloth-slider-prev')?.addEventListener('click', () => {
    if (clothSliderState.currentIndex > 0) clothSliderGoTo(clothSliderState.currentIndex - 1);
  });
  dialog.querySelector('.aipet-product-cloth-slider-next')?.addEventListener('click', () => {
    if (clothSliderState.currentIndex < clothSliderState.total - 1) clothSliderGoTo(clothSliderState.currentIndex + 1);
  });
});
